import type { SVGProps } from "react";

export const Avito = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
    <rect width="40" height="40" rx="12" fill="#5C5A57" fillOpacity=".1" />
    <path
      d="M23.15 25.25a9.6 9.6 0 0 1-9.6 9.6 9.6 9.6 0 1 1 9.6-9.6Z"
      fill="#04E061"
    />
    <path
      d="M19 10.9a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z"
      fill="#965EEB"
    />
    <path d="M35.7 13a7.8 7.8 0 1 1-15.6 0 7.8 7.8 0 0 1 15.6 0Z" fill="#0AF" />
    <path
      d="M36 27.85a5.8 5.8 0 1 1-11.6 0 5.8 5.8 0 0 1 11.6 0Z"
      fill="#FF4053"
    />
  </svg>
);

export const YandexEN = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" {...props}>
      <path
        fill="#FB3F1D"
        d="M0 19.2C0 12.48 0 9.12 1.3 6.55a12 12 0 0 1 5.25-5.24C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.65 1.3a12 12 0 0 1 5.24 5.25C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.3 12.65a12 12 0 0 1-5.25 5.24C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.65-1.3a12 12 0 0 1-5.24-5.25C0 30.88 0 27.52 0 20.8v-1.6Z"
      />
      <path
        fill="#fff"
        d="M20.54 21.4c1.17 2.56 1.56 3.45 1.56 6.52V32h-4.17v-6.87L10.05 8h4.36l6.13 13.4ZM25.7 8l-5.1 11.6h4.24L29.95 8h-4.26Z"
      />
    </svg>
  );
};

export const YandexRU = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" {...props}>
      <path
        fill="#FB3F1D"
        d="M0 19.2C0 12.48 0 9.12 1.3 6.55a12 12 0 0 1 5.25-5.24C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.65 1.3a12 12 0 0 1 5.24 5.25C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.3 12.65a12 12 0 0 1-5.25 5.24C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.65-1.3a12 12 0 0 1-5.24-5.25C0 30.88 0 27.52 0 20.8v-1.6Z"
      />
      <path
        fill="#fff"
        d="M22.79 11.24h-1.87c-3.42 0-5.23 1.74-5.23 4.3 0 2.88 1.25 4.24 3.8 5.97l2.12 1.42L15.54 32H11l5.45-8.11c-3.14-2.25-4.9-4.42-4.9-8.11 0-4.62 3.23-7.78 9.35-7.78h6.07v23.98H22.8V11.24Z"
      />
    </svg>
  );
};

export const Yango = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" {...props}>
      <path
        fill="red"
        d="M0 19.2C0 12.48 0 9.12 1.3 6.55a12 12 0 0 1 5.25-5.24C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.65 1.3a12 12 0 0 1 5.24 5.25C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.3 12.65a12 12 0 0 1-5.25 5.24C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.65-1.3a12 12 0 0 1-5.24-5.25C0 30.88 0 27.52 0 20.8v-1.6Z"
      />
      <path
        fill="#fff"
        d="M8.46 15.18H6.34l-.03 6.21-1.14 3.44h2.15l1.09-3.27 4.16-6.38h-2.4l-1.38 2.53c-.26.46-.46.88-.53 1.05l.1-1.17.1-2.4ZM8.18 24.83h2.19l.81-1.74h1.73l-.3 1.74h2.07l1.4-9.65h-2.9l-5 9.65Zm5.05-3.56h-1.18l1.46-3.1c.23-.47.4-.9.47-1.07l-.22 1.15-.53 3.02ZM20.42 15.18h-2.34l-3.2 9.65h1.97l1.66-5.04c.17-.5.3-.95.35-1.12l-.1 1.17-.3 5h2.29l3.2-9.66H22l-1.58 4.8c-.18.5-.3.95-.35 1.11 0-.17.05-.72.08-1.16l.28-4.75ZM26.33 21.19l-.04.12c-.3.91-.79 1.93-1.39 1.93-.68 0-.42-1.62.15-3.36.8-2.44 1.3-3.14 1.85-3.14.31 0 .52.32.59 1.42l1.91-.64c-.08-1.4-.74-2.53-2.3-2.53-1.77 0-3.19 1.51-4.18 4.54-.91 2.79-.83 5.37 1.09 5.37.66 0 1.12-.26 1.6-.84l-.14.77h1.54l1.82-5.46H25.9l-.6 1.82h1.03ZM30.9 25c1.67 0 3.14-1.49 4.12-4.52.9-2.78.9-5.48-1.73-5.48-1.67 0-3.14 1.5-4.12 4.53-.9 2.79-.9 5.48 1.73 5.48Zm.22-1.72c-.82 0-.34-1.8.19-3.4.8-2.48 1.3-3.15 1.76-3.15.8 0 .34 1.77-.19 3.4-.8 2.49-1.3 3.15-1.76 3.15Z"
      />
    </svg>
  );
};
